<template>
    <div class="profile-container"> 
      <form @submit.prevent="updateProfile">
        <div v-if="loading">{{ $t('common.loading') }}</div>
        <div v-else> 
        <div class="profile-info">
          <div>
            <p>{{ $t('profile.details.user_id') }}</p>
            <p>{{ profile.user_id }}</p>
          </div>
          <div>
            <p>{{ $t('profile.details.username') }}</p>
            <p>{{ profile.user_name }}</p>
          </div>
          <div>
            <p>{{ $t('profile.details.email') }}</p>
            <p>{{ profile.e_mail }}</p>
          </div>
          <div>
            <p>{{ $t('profile.details.registration_date') }}</p>
            <p>{{ formatDateTime(profile.registration_date) }}</p>
          </div>
          <div>
            <p>{{ $t('profile.details.last_login') }}</p>
            <p>{{ formatDateTime(profile.last_login) }}</p>
          </div>
          <div>
            <p>{{ $t('profile.details.verified_level') }}</p>  <img v-if="verifiedIcon" :src="verifiedIcon" @click="goToLevel" :alt="$t('profile.details.verified_level_alt')" class="verified-icon" />
          </div>
          <div>
            <p>{{ $t('profile.details.karma') }}</p>
            <p>{{ profile.karma }}</p>
          </div>
        </div>
  
          <div class="editable-fields">
            <label>{{ $t('profile.details.first_name') }}</label>
            <input type="text" v-model="profile.first_name" />
  
            <label>{{ $t('profile.details.last_name') }}</label>
            <input type="text" v-model="profile.last_name" />
  
            <label>{{ $t('profile.details.birth_date') }}</label>
            <input type="date" v-model="profile.birth_date" />
  
            <label>{{ $t('profile.details.gender') }}</label>
            <select v-model="profile.gender">
              <option value="Male">{{ $t('profile.details.gender_male') }}</option>
              <option value="Female">{{ $t('profile.details.gender_female') }}</option>
              <option value="Other">{{ $t('profile.details.gender_other') }}</option>
            </select>
  
            <label>{{ $t('profile.details.phone') }}</label>
            <input type="text" v-model="profile.phone_number" />
  
            <label>{{ $t('profile.details.country') }}</label>
            <input type="text" v-model="profile.country" />
  
            <label>{{ $t('profile.details.address') }}</label>
            <textarea v-model="profile.address"></textarea>
          </div>

          <div v-if="message" :class="['message', messageType]">
            {{ message }}
          </div>
          
          <button class="confirm" type="submit" :disabled="updating">{{ $t('profile.details.update_button') }}</button>
        </div>
      </form> 
      
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        profile: {},
        loading: true,
        updating: false,
        message: "",
        messageType: "", 
        messageTimeout: null,
      };
    },
    computed: {
      verifiedIcon() {
        return this.getVerifiedIcon(this.verifiedLevel);
      }
    },
    methods: {
      async fetchProfile() {
        try {
          const response = await axios.get("/promo/my-profile");
          if (response.data.success) {
            this.profile = response.data.data;
            this.verifiedLevel = response.data.data.verified_level;
          }
        } catch (error) {
          console.error("Profil alınırken hata oluştu:", error);
        } finally {
          this.loading = false;
        }
      },
      async updateProfile() {
        this.updating = true;
        this.clearMessage();
  
        try {
          const updatedData = {
            first_name: this.profile.first_name,
            last_name: this.profile.last_name,
            birth_date: this.profile.birth_date,
            gender: this.profile.gender,
            phone_number: this.profile.phone_number,
            country: this.profile.country,
            address: this.profile.address,
          };
  
          const response = await axios.post("/promo/update-my-profile", updatedData);
  
          if (response.data.success) {
            this.showMessage(this.$t('profile.details.update_success'), "success");
          } else {
            this.showMessage(response.data.message || this.$t('profile.details.update_failed'), "error");
          }
        } catch (error) {
          const msg =
            error.response?.data?.message ||
            this.$t('profile.details.unknown_error');
          this.showMessage(msg, "error");
          console.error("Profil güncellenirken hata oluştu:", error);
        } finally {
          this.updating = false;
        }
      },
      showMessage(msg, type = "success") {
        this.message = msg;
        this.messageType = type;
  
        clearTimeout(this.messageTimeout);
        this.messageTimeout = setTimeout(() => {
          this.clearMessage();
        }, 5000);
      },
      clearMessage() {
        this.message = "";
        this.messageType = "";
      },
      getVerifiedIcon(level) {
        if (!level || level === 0) {
          return "";
        }
  
        let iconPath = "";
        try {
          iconPath = require(`@/assets/icon/profile/level/${level}.svg`);
        } catch (e) {
          try {
            iconPath = require(`@/assets/icon/profile/level/${level}.png`);
          } catch (err) {
            console.warn(`Verified icon for level "${level}" not found.`);
          }
        }
        return iconPath;
      },
      goToLevel() {
        this.$router.push("/hesap-seviyeleri");
      },
    },
    mounted() {
      this.fetchProfile();
    }
  };
  </script>
  
  
  <style scoped>
  .profile-container {
    min-width: 50%;
    max-width: 1600px;
    margin: auto; 
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .editable-fields {
    padding: 5px;
  }

  .profile-info input,
  .editable-fields input,
  .editable-fields select,
  .editable-fields textarea {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
  } 
  
  button:disabled {
    background-color: #000000;
  }
  
  .message {
    margin-top: 0;
    padding: 10px;
    border-radius: 5px;
    font-weight: 500;
    animation: fadeIn 0.3s ease-in-out;
    transition: opacity 0.5s;
  }

  .message.success {
  color: #057742; 
}

.message.error {
  color: #c50e1e;  
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
 
  .profile-info {
    display: flex;
    flex-wrap: wrap;
    gap: 1em; 
    margin-bottom: 1rem;
  }

  .profile-info > div {
    display: flex; 
    flex-wrap: wrap;
    margin: 0;
    padding: 10px;
    background-color: #050505;
    border-radius: 4px;
    flex: 1 1 calc(33.333% - 32px);
    box-sizing: border-box;
  }

  .profile-info p {
    margin: 0;
  }

  .profile-info p:first-child {
    font-weight: 500;
    color: #187774;
    margin-right: 5px;
  }

  .profile-info p:last-child {
    color: #e0e0e0;
  }
  .verified-icon {
    max-width: 20px;
    margin-left: 5px;
    cursor: pointer ;
  }
  </style>
  